import * as React from "react";

const PhaseIcon = ({ fill, size }: { fill: string; size: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 23 23">
    <path fill={fill} d="M8 12.907 11.92 6l-.56 5.116H15L10.52 17l.56-4.093H8Z" />
    <circle cx={11.5} cy={11.5} r={11} stroke={fill} />
  </svg>
);
export default PhaseIcon;
